import React from 'react';
import lotharImg from './images/Lothar_Ueber-Mich.jpeg';
import ramonaimg from './images/ramona_Ueber-Mich.jpeg';
import marliesImg from './images/Marlies-Ueber-Mich.jpeg'

export default function Team() {
  const team = [
    {
      name: "Dr. med. Lothar Boso",
      role: "Facharzt Innere Medizin und Rheumatologie",
      description: "langjährige Erfahrung in Behandlung internistischer und rheumatologischer Erkrankungen",
      specialties: ["Innere Medizin", "Rheuma"],
      image: lotharImg
    },
    {
      name: "Ramona Boso",
      role: "Administration und pharmazeutische-kaufmännische Assistentin",
      description: "Ansprechpartnerin für Terminvereinbarungen und organisatorische Anliegen.",
      specialties: ["Administration", "Praxisorganisation", "Terminvereinbarung"],
      image: ramonaimg
    },
    {
      name: "Marlies Melk",
      role: "Sekretäriatskraft",
      description: "Ansprechpartnerin für Terminvereinbarungen und organisatorische Anliegen.",
      specialties: ["Administration", "Praxisorganisation", "Terminvereinbarung"],
      image: marliesImg
    }
  ];

  return (
    <section id="team" className="team">
      <div className="team-container">
        <div className="section-header">
          <h2 className="section-title">Unser Team</h2>
          <p className="section-description">
            Erfahrener Facharzt und qualifiziertes Personal für Ihre optimale Versorgung.
          </p>
        </div>

        <div className="team-grid">
          {team.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-card-header">
                <div className="team-avatar">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="team-avatar-img"
                  />
                </div>
              </div>
              <div className="team-card-body">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-description">{member.description}</p>

                <div className="team-specialties">
                  {member.specialties.map((specialty, i) => (
                    <span key={i} className="specialty-badge">
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
